/*!
 * customily-i18n-fr.js — Traduit l'UI Customily en français, côté client.
 *
 * Contexte : la boutique est en traductions natives Shopify → sur une page FR,
 * TOUT est déjà français SAUF l'UI Customily (app tierce, rendue en JS, non
 * couverte par les traductions Shopify). On traduit donc document-wide les
 * chaînes EXACTES du dictionnaire (clé = anglais) ; aucun risque de toucher du
 * contenu thème, qui est déjà FR. On exclut header/nav/footer/scripts par sûreté.
 *
 * SE CHARGE TOUJOURS, s'auto-active en FR uniquement (multi-signaux).
 * Idempotent (clés EN → une chaîne FR ne re-matche pas).
 *
 * Debug console : window.__customilyI18n.dump()  → liste les chaînes EN restantes
 *                 window.__customilyI18n.stats    → compteur de traductions
 *                 window.__customilyI18n.retranslate()
 *
 * Ajouter une traduction : "Texte EN exact": "Texte FR" dans DICT.
 */
(function () {
  'use strict';

  function isFR() {
    try {
      var sigs = [];
      if (window.Shopify && Shopify.locale) sigs.push(String(Shopify.locale));
      if (document.documentElement.lang) sigs.push(document.documentElement.lang);
      if (window.Shopify && Shopify.routes && Shopify.routes.root) sigs.push(Shopify.routes.root);
      sigs.push(location.pathname);
      for (var i = 0; i < sigs.length; i++) {
        var s = sigs[i].toLowerCase();
        if (s === 'fr' || s.indexOf('fr-') === 0 || /(^|\/)fr(\/|$)/.test(s)) return true;
      }
    } catch (e) {}
    return false;
  }
  if (!isFR()) { try { console.log('[customily-i18n-fr] locale non-FR, inactif'); } catch (e) {} return; }
  try { console.log('[customily-i18n-fr] actif (FR)'); } catch (e) {}

  // ——————————————————————————————————————————————————————————
  var DICT = {
    'Design My Card': 'Personnaliser ma carte',
    'Design my card': 'Personnaliser ma carte',
    'DESIGN MY CARD': 'PERSONNALISER MA CARTE',
    'Personalize': 'Personnaliser',
    'Personalize it': 'Personnaliser',
    'Personalize Now': 'Personnaliser',
    'Customize': 'Personnaliser',
    'Customize it': 'Personnaliser',
    // Boutons « Design It » des cartes de cross-sell (PAS le bouton PDP principal,
    // qui passe par localizeButton). Si le bouton n'est pas un BTN_SEL, le dico générique le traduit.
    'Design It': 'Personnaliser',
    'Design it': 'Personnaliser',
    'DESIGN IT': 'PERSONNALISER',
    // Titre d'étape du set Customily (enveloppes)
    'Envelope': 'Enveloppe',
    'ENVELOPE': 'ENVELOPPE',

    'Preview': 'Aperçu',
    'Show Preview': "Voir l'aperçu",
    'Hide Preview': "Masquer l'aperçu",
    'Share Customization': 'Partager la personnalisation',
    'Edit Personalization': 'Modifier la personnalisation',
    'Edit personalization': 'Modifier la personnalisation',
    'Edit': 'Modifier',
    'Remove': 'Retirer',
    'Required': 'Requis',
    'This field is required': 'Ce champ est requis',
    'Required options missing': 'Options requises manquantes',
    'Crop': 'Recadrer',
    'Done': 'Terminé',
    'Cancel': 'Annuler',
    'Apply': 'Appliquer',
    'Add to cart': 'Ajouter au panier',
    'Add to Cart': 'Ajouter au panier',
    'Add to bag': 'Ajouter au panier',
    'Close': 'Fermer',
    'Previous': 'Précédent',
    'Next': 'Suivant',
    'Back': 'Retour',
    'Click to zoom': 'Cliquer pour zoomer',
    'Tap to zoom': 'Toucher pour zoomer',
    'Upload': 'Téléverser',
    'Upload image': 'Téléverser une image',
    'Upload Image': 'Téléverser une image',
    'Choose file': 'Choisir un fichier',
    'Choose': 'Choisir',
    'Select': 'Sélectionner',
    'Color': 'Couleur',
    'Colour': 'Couleur',
    'Font': 'Police',
    'Font size': 'Taille de police',
    'Text': 'Texte',
    'Size': 'Taille',
    'Reset': 'Réinitialiser',
    'Save': 'Enregistrer',
    'Continue': 'Continuer',
    'Loading': 'Chargement',
    'Loading...': 'Chargement…',
    'Loading…': 'Chargement…',
    'Optional': 'Optionnel',
    'Optional personalization': 'Personnalisation optionnelle',

    // ——— Labels de champs / valeurs d'options (config Customily) ———
    // Champs & types
    'Position': 'Position',
    'Monogram': 'Monogramme',
    'Paper': 'Papier',
    'Dropdown': 'Liste déroulante',
    'Dropdown Swatch': 'Fil',
    'Swatch': 'Fil',
    'Text Input': 'Champ de texte',
    'Choose an Option': 'Choisir une option',
    'Front': 'Recto',
    'Back side': 'Verso',

    // Titres de sets
    'Business Cards   - Monogram': 'Cartes de visite - Monogramme',
    'Business Cards   - Monogram (Vertical)': 'Cartes de visite - Monogramme (vertical)',
    'Business Cards - Text': 'Cartes de visite - Texte',
    'Business Cards - Text (Vertical)': 'Cartes de visite - Texte (vertical)',

    // Couleurs / papiers
    'White': 'Blanc',
    'Natural': 'Naturel',
    'Velium White': 'Vélin blanc',
    'Navy Blue': 'Bleu marine',
    'Azure Blue': 'Bleu azur',
    'Baby Blue': 'Bleu layette',
    'Colonial Blue': 'Bleu colonial',
    'Cool Blue': 'Bleu froid',
    'French Blue': 'Bleu français',
    'Peacock Blue': 'Bleu paon',
    'Christmas Red': 'Rouge de Noël',
    'Crimson Red': 'Rouge cramoisi',
    'Fire Red': 'Rouge feu',
    'Poinsettia Red': 'Rouge poinsettia',
    'Chrome Orange': 'Orange chrome',
    'Lemon Yellow': 'Jaune citron',
    'Primrose Yellow': 'Jaune primevère',
    'Emerald Green': 'Vert émeraude',
    'Olive': 'Olive',
    'Pistachio': 'Pistache',
    'Magenta': 'Magenta',
    'Copper': 'Cuivre',
    'Gold': 'Or',
    'Silver': 'Argent',
    'Gloss Black': 'Noir brillant',
    'Medium Brown': 'Marron moyen',
    'Pale Grey': 'Gris pâle',
    'Quaker Gray': 'Gris Quaker',
    'Limestone': 'Calcaire',
    'Mist': 'Brume',

    // Fils — couleurs de broderie (Customily swatch, 26 teintes)
    'Red': 'Rouge',
    'Black': 'Noir',
    'Grey': 'Gris',
    'Coffee': 'Café',
    'Khaki': 'Kaki',
    'Wine Red': 'Rouge vin',
    'Rosy Red': 'Rouge rosé',
    'Beige Red': 'Rouge beige',
    'Flesh Pink': 'Rose chair',
    'Orange': 'Orange',
    'Golden Yellow': 'Jaune doré',
    'Light Purple': 'Violet clair',
    'Sky Blue': 'Bleu ciel',
    'Lake Blue': 'Bleu lac',
    'Royal Blue': 'Bleu roi',
    'Dark Blue': 'Bleu foncé',
    'Turquoise Blue': 'Bleu turquoise',
    'Water Green': "Vert d'eau",
    'Army Green': 'Vert armée',
    'Autumn Green': 'Vert automne',
    'Dark Green': 'Vert foncé',
    'Turquoise Green': 'Vert turquoise',
    'Fluorescent Green': 'Vert fluo',
    'Multicolour': 'Multicolore',

    // Positions du monogramme
    'Center Top': 'Centre haut',
    'Center Bottom': 'Centre bas',
    'Center': 'Centre',
    'Center Top / Center Bottom': 'Centre haut / Centre bas',
    'Center / Top (Vertical)': 'Centre / Haut (vertical)',
    'Upper Left': 'En haut à gauche',
    'Upper Left (Vertical)': 'En haut à gauche (vertical)',
    'Upper Left / Bottom Right': 'En haut à gauche / En bas à droite',
    'Upper Left / Center Bottom': 'En haut à gauche / Centre bas',
    'Upper Right': 'En haut à droite',
    'Upper Right / Bottom Left': 'En haut à droite / En bas à gauche',
    'Lower Left': 'En bas à gauche',
    'Lower Right': 'En bas à droite',
    // Positions (cartes de correspondance & papier à en-tête)
    'Top Left': 'En haut à gauche',
    'Top Right': 'En haut à droite',
    'Top Center': 'Centre haut',
    'Bottom Left': 'En bas à gauche',
    'Bottom Right': 'En bas à droite',
    'Bottom Center': 'Centre bas',
    'Left': 'Gauche',
    'Right': 'Droite',
    'Top Left / Top Right': 'En haut à gauche / En haut à droite',
    'Bottom Left / Bottom Right': 'En bas à gauche / En bas à droite',
    'Olive Green': 'Vert olive',
    // Carnets : positions, métaux, champs initiales
    'Center Left': 'Centre gauche',
    'Center Right': 'Centre droite',
    'Choose a Font': 'Choisir une police',
    'Light Silver': 'Argent clair',
    'Old Gold': 'Or vieilli',
    'Your Initials': 'Vos initiales',
    'Initials': 'Initiales',
    'By Character': 'Par caractère',
    'Initials - By Character - DRL': 'Initiales - par caractère - DRL',
    // Titres de sets (cartes de correspondance & papier à en-tête)
    'Correspondance Cards - Monogram': 'Cartes de correspondance - Monogramme',
    'Letterhead - Monogram': 'Papier à en-tête - Monogramme',
    'Letterhead - Monogram A5': 'Papier à en-tête - Monogramme A5',
    'Letterhead - Text': 'Papier à en-tête - Texte',
    'Letterhead - Text A5': 'Papier à en-tête - Texte A5',

    // Enveloppes
    '"Col Claudine" In White - 50 pcs': '« Col Claudine » en blanc - 50 pièces',
    '"Col Claudine" in Blue - 50 pcs': '« Col Claudine » en bleu - 50 pièces',
    '"Patte Pointue" In Blue - 50 pcs': '« Patte Pointue » en bleu - 50 pièces',
    '"Patte Pointue" In White - 50 pcs': '« Patte Pointue » en blanc - 50 pièces',
    // Enveloppes : titres de sets (Front=Recto, Back=Verso) — tous les blocs monogramme
    'C6 Envelope - Monogram Rond': 'Enveloppe C6 - Monogramme Rond',
    'C5 Envelope - Monogram Rond': 'Enveloppe C5 - Monogramme Rond',
    'Business Card Envelope - Monogram - Rond': 'Enveloppe carte de visite - Monogramme - Rond',
    'C6 Envelope - Monogram Papillon': 'Enveloppe C6 - Monogramme Papillon',
    'C5 Envelope - Monogram Papillon': 'Enveloppe C5 - Monogramme Papillon',
    'Business Card Envelope - Monogram Papillon': 'Enveloppe carte de visite - Monogramme Papillon',
    'C6 Envelope - Monogram Col Rond': 'Enveloppe C6 - Monogramme Col rond',
    'C5 Envelope - Monogram Col Rond': 'Enveloppe C5 - Monogramme Col rond',
    'C6 Envelope - Monogram Patte Pointue': 'Enveloppe C6 - Monogramme Patte pointue',
    'C5 Envelope - Monogram Patte Pointue': 'Enveloppe C5 - Monogramme Patte pointue',
    'C6 Envelope - Monogram Trapeze': 'Enveloppe C6 - Monogramme Trapèze',
    'C5 Envelope - Monogram Trapeze': 'Enveloppe C5 - Monogramme Trapèze',
    // Enveloppes : couleur + position du monogramme (Front=Recto, Back=Verso, Top=Haut, Bottom/Lower=Bas, Upper=Haut, Center=Centre, Landscape=paysage)
    'Natural - Front / Top': 'Naturel - Recto / Haut',
    'Natural - Front / Center': 'Naturel - Recto / Centre',
    'Natural - Front / Bottom': 'Naturel - Recto / Bas',
    'Natural - Back / Top': 'Naturel - Verso / Haut',
    'Natural - Back / Upper': 'Naturel - Verso / Haut',
    'Natural - Back / Center': 'Naturel - Verso / Centre',
    'Natural - Back / Lower': 'Naturel - Verso / Bas',
    'Natural - Front / Top (Landscape)': 'Naturel - Recto / Haut (paysage)',
    'Natural - Front / Center (Landscape)': 'Naturel - Recto / Centre (paysage)',
    'Natural - Back / Top (Landscape)': 'Naturel - Verso / Haut (paysage)',
    'Azur Blue - Front / Top': 'Bleu azur - Recto / Haut',
    'Azure Blue - Front / Top': 'Bleu azur - Recto / Haut',
    'Azure Blue - Front / Upper': 'Bleu azur - Recto / Haut',
    'Azure Blue - Front / Center': 'Bleu azur - Recto / Centre',
    'Azure Blue - Front / Bottom': 'Bleu azur - Recto / Bas',
    'Azure Blue - Back / Top': 'Bleu azur - Verso / Haut',
    'Azure Blue - Back / Upper': 'Bleu azur - Verso / Haut',
    'Azure Blue - Back / Center': 'Bleu azur - Verso / Centre',
    'Azure Blue - Back / Lower': 'Bleu azur - Verso / Bas',
    'Azure Blue - Front / Top (Landscape)': 'Bleu azur - Recto / Haut (paysage)',
    'Azure Blue - Front / Center (Landscape)': 'Bleu azur - Recto / Centre (paysage)',
    'Azure Blue - Back / Top (Landscape)': 'Bleu azur - Verso / Haut (paysage)',

    // Partage de la création
    'Share your design': 'Partagez votre création',
    'Or copy link': 'Ou copier le lien',
    'Copy': 'Copier',
    'Copied': 'Copié',
    'Copied!': 'Copié !',

    // Générique éditeur (chrome non couvert plus haut)
    'Quantity': 'Quantité',
    'Qty': 'Qté',
    'Landscape': 'Paysage',
    'Portrait': 'Portrait',
    'Add': 'Ajouter',
    'Delete': 'Supprimer',
    'Duplicate': 'Dupliquer',
    'Front side': 'Recto',
    'Back': 'Retour',

    // aria-labels de navigation
    'left arrow': 'flèche gauche',
    'right arrow': 'flèche droite'
  };

  // Valeurs FR (pour ne pas re-proposer en dump ce qui est déjà traduit)
  var FR_VALUES = {};
  for (var key in DICT) if (DICT.hasOwnProperty(key)) FR_VALUES[DICT[key]] = true;

  // Conteneurs à NE PAS traduire (chrome thème déjà FR)
  var EXCLUDE_SEL = 'script,style,noscript,template,header,nav,footer,' +
    '[role="banner"],[role="navigation"],[role="contentinfo"],' +
    '#header-component,.header,.footer,.section-header,.section-footer';

  var stats = { count: 0 };

  function excluded(el) {
    return !!(el && el.closest && el.closest(EXCLUDE_SEL));
  }

  function translatePhrase(raw) {
    if (!raw) return null;
    var t = raw.trim();
    if (!t || t.length > 80) return null;
    var fr = DICT[t];
    if (fr == null) { // tolère les espaces internes multiples (titres de sets Customily)
      var tn = t.replace(/\s+/g, ' ');
      if (tn !== t) fr = DICT[tn];
    }
    if (fr != null) return raw.replace(t, fr);
    var m = t.match(/^Option\s+(\d+)\s+of\s+(\d+)$/i);
    if (m) return raw.replace(t, 'Option ' + m[1] + ' sur ' + m[2]);
    var m2 = t.match(/^(\d+)\s+of\s+(\d+)$/);
    if (m2) return raw.replace(t, m2[1] + ' sur ' + m2[2]);
    return null;
  }

  // Le bouton « personalize » est traduit SÉPARÉMENT (libellé par produit), pas
  // par le dico générique — car son texte ("Design My Card") est identique sur
  // tous les produits mais doit différer (ex. en-tête → "Composer ma feuille").
  var BTN_SEL = '#customily-personalize-button,.customily-personalize-button,.cstm-open-btn';
  function buttonLabel() {
    var p = (location.pathname || '').toLowerCase();
    if (p.indexOf('letterhead') !== -1) return 'Composer ma feuille';
    if (p.indexOf('notebook') !== -1 || p.indexOf('carnet') !== -1) return 'Ajouter mes initiales';
    // enveloppes : seul « business-card-with-envelope » est une carte (livrée avec enveloppe)
    if ((p.indexOf('envelope') !== -1 || p.indexOf('enveloppe') !== -1) &&
        p.indexOf('business-card-with-envelope') === -1)
      return 'Personnaliser mon enveloppe';
    return 'Personnaliser ma carte';
  }
  // Libellés EN posés par les scripts Customily (PDP « Design My Card » + cartes
  // de reco/cross-sell « Design It ») et nos propres libellés FR (pour re-corriger
  // si Customily réécrit le bouton). On ne touche QUE ces libellés connus.
  var BTN_EN = /^(design\s*(my)?\s*(card|sheet)|add\s*my\s*(monogram|initials?)|design\s*it|personn?aliz[se]|customi[sz]e|edit\s*design|start\s*designing)$/i;
  var BTN_FR = /^(personnaliser( ma carte| mon enveloppe)?|composer ma feuille|ajouter mes initiales)$/i;
  function localizeButton() {
    var btns = document.querySelectorAll(BTN_SEL);
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i];
      // bouton principal PDP = libellé par produit ; déclencheurs secondaires
      // (cartes cross-sell « Design It ») = libellé générique court.
      var isMain = b.id === 'customily-personalize-button' ||
        (b.classList && b.classList.contains('customily-personalize-button'));
      var want = isMain ? buttonLabel() : 'Personnaliser';
      var cur = (b.textContent || '').trim();
      if (cur === want) continue;
      if (BTN_EN.test(cur) || BTN_FR.test(cur)) { b.textContent = want; stats.count++; }
    }
  }

  var ATTRS = ['placeholder', 'title', 'aria-label', 'alt'];
  function translateEl(el) {
    if (!el || el.nodeType !== 1) return;
    if (excluded(el)) { if (el.shadowRoot) walk(el.shadowRoot); return; }
    for (var i = 0; i < ATTRS.length; i++) {
      var a = ATTRS[i];
      if (el.hasAttribute && el.hasAttribute(a)) {
        var nv = translatePhrase(el.getAttribute(a));
        if (nv != null && nv !== el.getAttribute(a)) { el.setAttribute(a, nv); stats.count++; }
      }
    }
    if (el.tagName === 'INPUT') {
      var ty = (el.getAttribute('type') || '').toLowerCase();
      if (ty === 'button' || ty === 'submit') {
        var v = translatePhrase(el.value);
        if (v != null && v !== el.value) { el.value = v; stats.count++; }
      }
    }
    if (el.shadowRoot) walk(el.shadowRoot);
  }

  function translateTextNode(n) {
    var p = n.parentElement;
    if (!p || excluded(p)) return;
    if (p.isContentEditable) return;
    var tag = p.tagName;
    // On NE traduit PAS le texte saisi par l'utilisateur (input/textarea).
    // Les <option> SONT traduites : Customily lit l'attribut value, pas le texte.
    if (tag === 'TEXTAREA' || tag === 'INPUT') return;
    if (p.closest && p.closest(BTN_SEL)) return; // bouton géré par localizeButton()
    var nv = translatePhrase(n.nodeValue);
    if (nv != null && nv !== n.nodeValue) { n.nodeValue = nv; stats.count++; }
  }

  function walk(root) {
    if (!root) return;
    if (root.nodeType === 1) {
      translateEl(root);
      var els = root.querySelectorAll ? root.querySelectorAll('*') : [];
      for (var i = 0; i < els.length; i++) translateEl(els[i]);
    } else if (root.querySelectorAll) {
      var els2 = root.querySelectorAll('*');
      for (var k = 0; k < els2.length; k++) translateEl(els2[k]);
    }
    var tw = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var batch = [], n;
    while ((n = tw.nextNode())) batch.push(n);
    for (var j = 0; j < batch.length; j++) translateTextNode(batch[j]);
  }

  function translateNode(node) {
    if (node.nodeType === 3) { translateTextNode(node); return; }
    if (node.nodeType === 1) walk(node);
  }

  var pending = false, queue = [];
  function flush() {
    pending = false;
    var q = queue; queue = [];
    for (var i = 0; i < q.length; i++) { try { translateNode(q[i]); } catch (e) {} }
    try { localizeButton(); } catch (e) {}
  }
  function schedule(node) {
    queue.push(node);
    if (!pending) { pending = true; (window.requestAnimationFrame || window.setTimeout)(flush, 16); }
  }

  function retranslate() { try { walk(document.body); } catch (e) {} }

  // ——— Debug : liste les chaînes EN restantes dans les zones Customily ———
  function dump() {
    var SEL = '[class*="customily"],[id*="customily"],[class*="csh-"],[class*="cstm"],' +
      '[class*="product_personalizer"],[class*="product-personalizer"],' +
      '#customily-personalize-button,.cstm-open-btn';
    var roots = document.querySelectorAll(SEL);
    var seen = {}, out = [];
    function collectFrom(node) {
      var tw = document.createTreeWalker(node, NodeFilter.SHOW_TEXT, null), n;
      while ((n = tw.nextNode())) {
        var t = (n.nodeValue || '').trim();
        if (!t || t.length > 80) continue;
        if (!/[A-Za-z]/.test(t)) continue;            // ignore chiffres/symboles
        if (FR_VALUES[t]) continue;                    // déjà traduit
        if (/[éèàùçêâîôûëï]/i.test(t)) continue;        // déjà français (accents)
        if (DICT[t]) continue;                         // déjà dans le dico
        if (!seen[t]) { seen[t] = 1; out.push(t); }
      }
      // attributs utiles
      var els = node.querySelectorAll ? node.querySelectorAll('*') : [];
      for (var i = 0; i < els.length; i++) {
        for (var a = 0; a < ATTRS.length; a++) {
          var v = els[i].getAttribute && els[i].getAttribute(ATTRS[a]);
          if (v) { v = v.trim(); if (v && v.length <= 80 && /[A-Za-z]/.test(v) && !FR_VALUES[v] && !DICT[v] && !/[éèàùçêâîôûëï]/i.test(v) && !seen['@'+v]) { seen['@'+v]=1; out.push(v); } }
        }
        if (els[i].shadowRoot) collectFrom(els[i].shadowRoot);
      }
    }
    for (var r = 0; r < roots.length; r++) collectFrom(roots[r]);
    console.log('[customily-i18n-fr] conteneurs Customily trouvés:', roots.length,
                '| chaînes EN non traduites:', out.length);
    console.log(JSON.stringify(out, null, 2));
    return { containers: roots.length, untranslated: out };
  }

  window.__customilyI18n = { stats: stats, dict: DICT, retranslate: retranslate, dump: dump };

  function start() {
    try { walk(document.body); } catch (e) {}
    try {
      var obs = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var m = muts[i];
          if (m.type === 'characterData') { schedule(m.target); continue; }
          for (var k = 0; k < m.addedNodes.length; k++) schedule(m.addedNodes[k]);
          if (m.addedNodes.length === 0 && m.type === 'attributes') schedule(m.target);
        }
      });
      obs.observe(document.body, {
        childList: true, subtree: true, characterData: true,
        attributes: true, attributeFilter: ATTRS
      });
    } catch (e) { try { console.warn('[customily-i18n-fr] observer KO', e); } catch (e2) {} }

    var ticks = 0;
    var iv = setInterval(function () {
      localizeButton();
      if (++ticks > 80) {
        clearInterval(iv);
        try { console.log('[customily-i18n-fr] ' + stats.count + ' chaînes traduites. Tape __customilyI18n.dump() (éditeur ouvert) pour lister le reste.'); } catch (e) {}
      }
    }, 100);
  }

  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start);
})();
